import { render, staticRenderFns } from "./FloatContact.vue?vue&type=template&id=1aaa9c1a&scoped=true"
import script from "./FloatContact.vue?vue&type=script&lang=js"
export * from "./FloatContact.vue?vue&type=script&lang=js"
import style0 from "./FloatContact.vue?vue&type=style&index=0&id=1aaa9c1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaa9c1a",
  null
  
)

export default component.exports